// Where the account key lives in the browser that holds it (D41): the same IndexedDB
// store as the device keys, as a non-extractable CryptoKey that survives reloads but can
// be neither read nor exported by any script. Losing browser storage loses it; the
// recovery file brings it back (account/recovery.ts).
import { withStore } from "../device/store";
import type { AccountKey } from "./key";

const KEY = "account";

export async function saveAccountKey(key: AccountKey): Promise<void> {
  await withStore("readwrite", (s) => s.put(key, KEY));
}

export async function loadAccountKey(): Promise<AccountKey | undefined> {
  if (typeof indexedDB === "undefined") return undefined;
  const value: unknown = await withStore("readonly", (s) => s.get(KEY));
  return isAccountKey(value) ? value : undefined;
}

function isAccountKey(v: unknown): v is AccountKey {
  if (!v || typeof v !== "object") return false;
  const k = v as Partial<AccountKey>;
  return k.alg === "ecdsa_p256_sha256" && k.publicKey instanceof Uint8Array && typeof k.privateKey === "object";
}
